// 获取AppKey
function getDeviceInfo () {
  return new Promise((resolve, reject) => {
    document.addEventListener('deviceready', function () {
      window.cordova.exec((success) => {
        resolve(success.appKey)
      }, (error) => {
        reject("getDeviceInfo Error:" + JSON.stringify(error))
      }, 'MideaCommon', 'getDeviceInfo', [])
    }, false)
  })
}

function getUserToken () {
  return new Promise((resolve, reject) => {
    document.addEventListener('deviceready', function () {
      window.cordova.exec((success) => {
        resolve(success.ssoToken)
      }, (error) => {
        console.log('Error: ' + error)
        reject(error)
      }, 'MideaUser', 'getUser', [])
    }, false)
  })
}

export default { getUserToken, getDeviceInfo }